// import Vue from "vue";
// import VueRouter from "vue-router";

// Vue.use(VueRouter);

const routes = [
  // 无权限页面
  {
    path: "/rhwx/noPower",
    component: () => import("../noPower.vue"),
    meta: {
      title: "无权操作"
    }
  },
  // 确认扫码登录页面
  {
    path: "/rhwx/checkPcEqCodeLogin",
    component: () => import("../checkEqCode/Index.vue"),
    meta: {
      title: "确认登录"
    }
  },
  // 默认页面企业微信
  {
    path: "/rhwx",
    redirect: "/rhwxSignIn"
  },
  // 默认页面公众号
  {
    path: "/rhwxChat",
    redirect: "/rhwxSignIn"
  },
  // 司机签到
  {
    path: "/rhwxSignIn",
    name: "rhwxSignIn",
    component: () => import("../Driver/SignIn.vue"),
    meta: {
      title: "玖龙智通管理系统"
    }
  },
  // 签到成功提示
  {
    path: "/rhwxSignInSuccess",
    name: "rhwxSignInSuccess",
    component: () => import("../Driver/SignInSuccess.vue"),
    meta: {
      title: "现场报到"
    }
  },
  // 现场报到
  {
    path: "/rhwxCheckin/:id",
    name: "rhwxCheckin",
    component: () => import("../Driver/Checkin.vue"),
    meta: {
      title: "现场报到"
    }
  },
  // 安全告知书
  {
    path: "/rhwxNotice",
    name: "rhwxNotice",
    component: () => import("../Driver/Notice.vue"),
    meta: {
      title: "安全告知书"
    }
  },
  // 继续厂内作业
  {
    path: "/rhwxContinueInPlantOperation",
    name: "rhwxContinueInPlantOperation",
    component: () => import("../Driver/ContinueInPlantOperation.vue"),
    meta: {
      title: "继续厂内作业"
    }
  },
  // 排队看板
  {
    path: "/rhwxQueueBoard",
    name: "rhwxQueueBoard",
    component: () => import("../Queue/QueueBoard.vue"),
    meta: {
      title: "排队看板"
    }
  },
  // 调度员
  // 我的预约
  // --------------------- 普通预约 ----------------------
  {
    path: "/rhwxAppointList",
    name: "rhwxAppointList",
    component: () => import("../Control/AppointList.vue"),
    meta: {
      title: "我的预约",
      keepAlive: true
    }
  },
  // 加入成品排队
  {
    path: "/rhwxReJoinline",
    name: "rhwxReJoinline",
    component: () => import("../Control/ReJoinline.vue"),
    meta: {
      title: "加入成品排队",
      keepAlive: false
    }
  },
  // 查看预约（预约详情）
  {
    path: "/rhwxAppointDetail",
    name: "rhwxAppointDetail",
    component: () => import("../Control/AppointDetail.vue"),
    meta: {
      title: "查看预约信息"
    }
  },
  // 编辑预约信息
  {
    path: "/rhwxAppointModify/:id",
    name: "rhwxAppointModify",
    component: () => import("../Control/AppointModify.vue"),
    meta: {
      title: ""
    }
  },
  // 编辑预约信息（原料入厂）
  {
    path: "/rhwxAppointMaterialsModify/:id",
    name: "rhwxAppointMaterialsModify",
    component: () => import("../Control/AppointMaterialsModify.vue"),
    meta: {
      title: ""
    }
  },
  // 添加预约信息
  {
    path: "/rhwxAppointAdd",
    name: "rhwxAppointAdd",
    component: () => import("../Control/AppointAdd.vue"),
    meta: {
      title: "添加预约"
    }
  },
  // 预约时间
  {
    path: "/rhwxAppointTime",
    name: "rhwxAppointTime",
    component: () => import("../Control/AppointTime.vue"),
    meta: {
      title: "选择预约时间"
    }
  },
  // 预约成功
  {
    path: "/rhwxAppointSuccess",
    name: "rhwxAppointSuccess",
    component: () => import("../Control/AppointSuccess.vue"),
    meta: {
      title: "预约成功"
    }
  },
  // 添加车辆
  {
    path: "/rhwxAppointVehicleAdd",
    name: "rhwxAppointVehicleAdd",
    component: () => import("../Control/AppointVehicleAdd.vue"),
    meta: {
      title: "添加车辆"
    }
  },
  // --------------------- 应急预约 ----------------------
  {
    path: "/rhwxEmergeAppointList",
    name: "rhwxEmergeAppointList",
    component: () => import("../EmergeAppoint/AppointList.vue"),
    meta: {
      title: "我的预约",
      keepAlive: true
    }
  },
  // 查看预约（预约详情）
  {
    path: "/rhwxEmergeAppointDetail",
    name: "rhwxEmergeAppointDetail",
    component: () => import("../EmergeAppoint/AppointDetail.vue"),
    meta: {
      title: "查看预约信息"
    }
  },
  // 编辑预约信息
  {
    path: "/rhwxEmergeAppointModify/:id",
    name: "rhwxEmergeAppointModify",
    component: () => import("../EmergeAppoint/AppointModify.vue"),
    meta: {
      title: ""
    }
  },
  // 添加预约信息
  {
    path: "/rhwxEmergeAppointAdd",
    name: "rhwxEmergeAppointAdd",
    component: () => import("../EmergeAppoint/AppointAdd.vue"),
    meta: {
      title: "添加预约"
    }
  },
  // 预约时间
  {
    path: "/rhwxEmergeAppointTime",
    name: "rhwxEmergeAppointTime",
    component: () => import("../EmergeAppoint/AppointTime.vue"),
    meta: {
      title: "选择预约时间"
    }
  },
  // 预约成功
  {
    path: "/rhwxEmergeAppointSuccess",
    name: "rhwxEmergeAppointSuccess",
    component: () => import("../EmergeAppoint/AppointSuccess.vue"),
    meta: {
      title: "预约成功"
    }
  },
  // ---------------------- 结束 -------------------------
  // 拍照指引
  {
    path: "/rhwxPhotoGuide",
    name: "rhwxPhotoGuide",
    component: () => import("../Control/PhotoGuide.vue"),
    meta: {
      title: "证件拍照指引"
    }
  },
  // 厂区指引
  {
    path: "/rhwxRouteGuide",
    name: "rhwxRouteGuide",
    component: () => import("../Control/RouteGuide.vue"),
    meta: {
      title: "厂区指引"
    }
  },  
  // 预约记录管理
  {
    path: "/AppointRecord",
    name: "AppointRecord",
    component: () => import("../Control/AppointRecord.vue"),
    meta: {
      title: "预约记录管理"
    }
  },
  // 车辆计划
  {
    path: "/AppointCarListPlan",
    name: "AppointCarListPlan",
    component: () => import("../Control/AppointCarListPlan.vue"),
    meta: {
      title: "车辆计划"
    }
  },
  // 监装员
  // 排队管理
  {
    path: "/rhwxStoreQueueList",
    name: "rhwxStoreQueueList",
    component: () => import("../Store/StoreQueueList.vue"),
    meta: {
      title: "排队管理"
    }
  },
  // 车辆叫号
  {
    path: "/rhwxStoreCalling",
    name: "rhwxStoreCalling",
    component: () => import("../Store/StoreCalling.vue"),
    meta: {
      title: "车辆叫号"
    }
  },
  // 排序管理应用
  {
    path: "/rhwxStoreActionList",
    name: "rhwxStoreActionList",
    component: () => import("../StoreAction/StoreActionList.vue"),
    meta: {
      title: "排序管理"
    }
  },
  // 合作单位
  // openid 登陆跳转
  {
    path: "/rhwxOpenIdLogin",
    name: "rhwxOpenIdLogin",
    component: () => import("../Cooperate/openidLogin.vue"),
    meta: {
      title: "合作单位登录"
    }
  },
  // 登录
  {
    path: "/rhwxLogin",
    name: "rhwxLogin",
    component: () => import("../Cooperate/Login.vue"),
    meta: {
      title: "合作单位登录"
    }
  },
  // 欢迎页
  {
    path: "/rhwxWelcome",
    name: "rhwxWelcome",
    component: () => import("../Cooperate/Welcome.vue"),
    meta: {
      title: "合作单位主页"
    }
  },
  // 修改登录密码
  {
    path: "/rhwxPwdModify",
    name: "rhwxPwdModify",
    component: () => import("../Cooperate/PwdModify.vue"),
    meta: {
      title: "修改登录密码"
    }
  },
  // 单位信息查看
  {
    path: "/rhwxInfoDetail",
    name: "rhwxInfoDetail",
    component: () => import("../Cooperate/InfoDetail.vue"),
    meta: {
      title: "单位信息查看"
    }
  },
  // 编辑单位信息
  {
    path: "/rhwxInfoModify",
    name: "rhwxInfoModify",
    component: () => import("../Cooperate/InfoModify.vue"),
    meta: {
      title: ""
    }
  },
  // 退出登录
  {
    path: "/rhwxLogout",
    name: "rhwxLogout",
    component: () => import("../Cooperate/Logout.vue"),
    meta: {
      title: "退出登录"
    }
  },
  // 领导
  // 每日发运车辆统计
  {
    path: "/rhwxVehicleStatis",
    name: "rhwxVehicleStatis",
    component: () => import("../Leader/VehicleStatis.vue"),
    meta: {
      title: "车辆统计"
    }
  },
  // 每周装车效率分析
  {
    path: "/rhwxReportLoading",
    name: "rhwxReportLoading",
    component: () => import("../Leader/reportLoading.vue"),
    meta: {
      title: "车辆统计"
    }
  },
  // 每周发运车辆统计
  {
    path: "/rhwxReportShipment",
    name: "rhwxReportShipment",
    component: () => import("../Leader/reportShipment.vue"),
    meta: {
      title: "车辆统计"
    }
  },
  // 每周到车质量统计
  {
    path: "/rhwxReportArriveBus",
    name: "rhwxReportArriveBus",
    component: () => import("../Leader/reportArriveBus.vue"),
    meta: {
      title: "车辆统计"
    }
  },
  // 审批跳过
  {
    path: "/rhwxApprovalInfo/:id?",
    name: "rhwxApprovalInfo",
    component: () => import("../Leader/ApprovalInfo.vue"),
    meta: {
      title: "EIP流程情况汇总"
    }
  },
  // 每周到车质量统计(不做)
  // {
  //   path: "/rhwxReportArriveBus",
  //   name: "rhwxReportArriveBus",
  //   component: () => import("../Leader/reportArriveBus.vue"),
  //   meta: {
  //     title: "车辆统计"
  //   }
  // }
  // ---------------------- 地磅对接 -------------------------
  {
    path: "/rhwxWeighbridgeIndex",
    name: "rhwxWeighbridgeIndex",
    component: () => import("../weighbridgeSys/Index.vue"),
    meta: {
      title: "查看称重明细"
    }
  },
  // 一码通入口
  {
    path: "/rhwxIntoCodeAllPath",
    name: "rhwxIntoCodeAllPath",
    component: () => import("../IntoCode/AllPath.vue"),
    meta: {
      title: "玖龙智通管理系统"
    }
  },
  // 关注公众号
  {
    path: "/rhwxIntoCodeFollowCode",
    name: "rhwxIntoCodeFollowCode",
    component: () => import("../IntoCode/FollowCode.vue"),
    meta: {
      title: "关注公众号"
    }
  },
  // 篷布确认成功页面
  {
    path: "/rhwxEvaluateResult",
    name: "rhwxEvaluateResult",
    component: () => import("../Evaluate/Result.vue"),
    meta: {
      title: "篷布防护确认"
    }
  },
  // 司机确认篷布页面校验当前是否需要盖篷布
  {
    path: "/rhwxEvaluateCheckInBefore",
    name: "rhwxEvaluateCheckInBefore",
    component: () => import("../Evaluate/CheckInBefore.vue"),
    meta: {
      title: "篷布防护确认"
    }
  },
  // 司机确认篷布页面
  {
    path: "/rhwxEvaluateCheckIn",
    name: "rhwxEvaluateCheckIn",
    component: () => import("../Evaluate/CheckIn.vue"),
    meta: {
      title: "篷布防护确认"
    }
  },
  // 不需要登录的业务面-》获取登录态
  {
    path: "/rhwxWxChatLogin",
    name: "rhwxWxChatLogin",
    component: () => import("../wxChatLogin.vue"),
    meta: {
      title: ""
    }
  }
];

// const router = new VueRouter({
//   routes
// });

// router.beforeEach((to, from, next) => {
//   document.body.scrollTop = 0;
//   next();
// });

// router.afterEach((to, from) => {
//   let bodySrcollTop = document.body.scrollTop;
//   if (bodySrcollTop !== 0) {
//     document.body.scrollTop = 0;
//     return;
//   }
//   let docSrcollTop = document.documentElement.scrollTop;
//   if (docSrcollTop !== 0) {
//     document.documentElement.scrollTop = 0;
//   }
// });

export default routes;
